import {config, tracker} from "../vendor/youserxp.umd";
import GigyaManager from "./GigyaManager";
import PrivacyCluster from "../enums/PrivacyCluster";
import $ from "jquery";

class Tracker {
    constructor(params = {}) {
        this.isTrackerReady = this.init(params);
    }

    init({trackId}) {
        return new Promise((resolve, reject) => {
            config({
                host: API_ENDPOINT
            });

            let trackingId = !!window.MB_TRACKING_ID ? window.MB_TRACKING_ID : "KIDS2019";
            if (trackId) {
                trackingId = trackId;
            }
            // this.instance = tracker.getInstance({trackingId: trackingId});
            this.instance = new tracker.Tracker({trackingId: trackingId});

            let localStorage = window.localStorage;


            this.user = {UID: "ANONYMOUS", privacyCluster: null};

            GigyaManager.getPrivacyCluster().then((privacyCluster) => {
                this.user.privacyCluster = privacyCluster;
                if (PrivacyCluster.U2 == privacyCluster || PrivacyCluster.U4 == privacyCluster || PrivacyCluster.U1 == privacyCluster || PrivacyCluster.U3 == privacyCluster) {
                    GigyaManager.getLoggedUserCached().then((d) => {
                        this.user.UID = d.UID;
                        resolve(true);
                    }, () => {
                        //NOOP
                    });
                } else {
                    resolve(true);
                }

                this.listenForTrackingEvent();
            });
        });
    }


    send(eventType, payload) {
        return this.isTrackerReady.then(() => {
            var p = $.extend({
                contactId: this.user.UID,
                contactIdOrigin: this.user.UID,
                sourceUrl: window.location.href,
                sessionId: {udid: this.udid},
                privacyCluster: this.user.privacyCluster
            }, payload);

            return this.instance.send(eventType, {payload: p}, "worker");
        });

    }

    listenForTrackingEvent() {
       /* window.document.addEventListener(Constants.events.tracking.SEND, (event) => {
            let eventData = event.detail;
            this.send(eventData.eventName, eventData.params, eventData.mode);
        });*/
    }


}

export const getTracker = (params) => {
    return new Tracker(params);
};
export default new Tracker();
